// @flow
import * as React from 'react';

import { LoadingIndicatorContainer, LoadingIndicatorContent } from './styles';

import WaitingIndicator from '~/components/widgets/indicators/waiting';

type Props = {
    children: React.Node,
    isLoading: boolean
};

export default function LoadingIndicator({ children, isLoading }: Props) {
    if (isLoading) {
        return (
            <LoadingIndicatorContainer>
                <LoadingIndicatorContent>
                    <WaitingIndicator show />
                </LoadingIndicatorContent>
            </LoadingIndicatorContainer>
        );
    }

    return <div>{children}</div>;
}



// WEBPACK FOOTER //
// ./src/components/widgets/indicators/loading/index.js